import { Box, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import Link from '../Link/Link';
import Slider from '../Slider/Slider';
import { Chip, Headline, InfoWrapper, Wrapper } from './HowItWorksMobile.style';

const HowItWorksMobile = ({ data }) => {
  const {
    tag,
    headline,
    subline,
    description,
    link,
    openInNewTab,
    steps,
  } = data;

  return (
    <Wrapper>
      <Stack direction="column" mb={6}>
        {tag && (
          <Chip size="small" uppercase>
            {tag}
          </Chip>
        )}
        <Headline
          variant="h2Redesign"
          component="h2"
          color="primary.dark"
          data-test-subject="headline">
          {headline}
        </Headline>
        <Typography
          data-test-subject="subline"
          variant="h5Redesign"
          component="p"
          color="text.secondary"
          mb={description || link ? 3.5 : 0}>
          {subline}
        </Typography>
        {description && (
          <Typography
            data-test-subject="description"
            component="p"
            variant="body1Redesign"
            mb={link ? 1.5 : 0}
            color="text.secondary">
            {description}
          </Typography>
        )}
        {link && (
          <Link
            link={link}
            openInNewTab={openInNewTab}
            dataTestSubject="link"
          />
        )}
      </Stack>
      {steps.map(({ headline, text, link, openInNewTab, slides }, index) => (
        <Stack key={index} mb={6.5} data-test-subject="step">
          <InfoWrapper>
            <Typography
              data-test-subject="headline"
              variant="h4Redesign"
              component="h3"
              color="primary">
              {headline}
            </Typography>
            {text && (
              <Typography
                data-test-subject="text"
                variant="body1Redesign"
                component="p"
                mt={1.5}
                color="text.secondary">
                {text}
              </Typography>
            )}
            {link && (
              <Box mt={1.5}>
                <Link
                  link={link}
                  openInNewTab={openInNewTab}
                  dataTestSubject="link"
                />
              </Box>
            )}
          </InfoWrapper>
          <Slider slides={slides} fullWidth />
        </Stack>
      ))}
    </Wrapper>
  );
};

HowItWorksMobile.propTypes = {
  data: PropTypes.shape({
    tag: PropTypes.string,
    headline: PropTypes.string.isRequired,
    subline: PropTypes.string.isRequired,
    description: PropTypes.string,
    link: PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
    steps: PropTypes.arrayOf(
      PropTypes.shape({
        headline: PropTypes.string.isRequired,
        text: PropTypes.string,
        link: PropTypes.shape({
          text: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
        }),
        slides: PropTypes.arrayOf(
          PropTypes.shape({
            image: PropTypes.shape({
              url: PropTypes.string.isRequired,
              alt: PropTypes.string,
            }).isRequired,
          }).isRequired
        ).isRequired,
      }).isRequired
    ).isRequired,
  }).isRequired,
};

export default HowItWorksMobile;
